var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlayStoreLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#a5a5a4;}.cls-2{fill:#020303;}.cls-3,.cls-4{fill:#fff;}.cls-3{stroke:#fff;stroke-miterlimit:10;stroke-width:0.27px;}.cls-5{fill:#74c8f1;}.cls-6{fill:url(#linear-gradient);}.cls-7{fill:url(#linear-gradient-2);}.cls-8{fill:url(#linear-gradient-3);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 46.06,
    y1: -52.32,
    x2: 10.24,
    y2: -52.32,
    gradientTransform: "matrix(1, 0, 0, -1, 0, -18)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdf10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#fabc11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#f7a50f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f59b12"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 36.77,
    y1: -55.7,
    x2: 3.07,
    y2: -89.4,
    gradientTransform: "matrix(1, 0, 0, -1, 0, -18)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e6393e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c71768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 2.92,
    y1: -15.07,
    x2: 30.43,
    y2: -42.58,
    gradientTransform: "matrix(1, 0, 0, -1, 0, -18)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#219866"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#35a064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#5cb060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#75b95c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7fbd5c"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Untitled-1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M184.07,1.56H12.57a23.3,23.3,0,0,0-3.35.3A11.3,11.3,0,0,0,6,2.93a10.47,10.47,0,0,0-2.7,2,10.17,10.17,0,0,0-3,5.89A20.59,20.59,0,0,0,0,14.14V55.85a20.66,20.66,0,0,0,.33,3.34,10.49,10.49,0,0,0,1,3.19,10.19,10.19,0,0,0,2,2.7,10.24,10.24,0,0,0,2.7,2,10.72,10.72,0,0,0,3.18,1,22,22,0,0,0,3.35.31H187.42a24.83,24.83,0,0,0,3.34-.31A11.55,11.55,0,0,0,194,67.05a10.36,10.36,0,0,0,2.69-2,10.7,10.7,0,0,0,2-2.69,11,11,0,0,0,1-3.19,21,21,0,0,0,.31-3.34V14.1a20.76,20.76,0,0,0-.31-3.35,10.72,10.72,0,0,0-1-3.18A10.83,10.83,0,0,0,194,2.93a12,12,0,0,0-3.19-1,26.91,26.91,0,0,0-3.34-.3h-3.36Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M14.11,67H12.6a20.33,20.33,0,0,1-3.12-.28,9.3,9.3,0,0,1-2.77-.91,9.2,9.2,0,0,1-4-4A9,9,0,0,1,1.76,59a20.46,20.46,0,0,1-.28-3.13V14.18a20.69,20.69,0,0,1,.28-3.13,9.26,9.26,0,0,1,.91-2.78,9,9,0,0,1,1.7-2.34A9.46,9.46,0,0,1,6.71,4.22a10.26,10.26,0,0,1,2.76-.9A23.34,23.34,0,0,1,12.61,3H187.39a22.89,22.89,0,0,1,3.11.28,9.93,9.93,0,0,1,2.79.91A9.16,9.16,0,0,1,198.18,11a19.74,19.74,0,0,1,.29,3.15V55.8a21.39,21.39,0,0,1-.28,3.1,9.3,9.3,0,0,1-7.7,7.7,20.33,20.33,0,0,1-3.12.28H14.11Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M70.25,19.85a4,4,0,0,1-1.11,3,4.3,4.3,0,0,1-3.26,1.31,4.57,4.57,0,0,1-4.62-4.53v-.11a4.58,4.58,0,0,1,4.53-4.64.14.14,0,0,1,.09,0,4.45,4.45,0,0,1,1.83.38,3.81,3.81,0,0,1,1.39,1l-.78.8A3,3,0,0,0,65.88,16a3.3,3.3,0,0,0-2.42,1,3.35,3.35,0,0,0-1,2.56,3.38,3.38,0,0,0,1,2.55,3.3,3.3,0,0,0,2.42,1,3.34,3.34,0,0,0,2.49-1,2.85,2.85,0,0,0,.74-1.79H65.88V19.18h4.31A3.88,3.88,0,0,1,70.25,19.85Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M77.08,16.13H73V19h3.65v1H73v2.83h4v1.09H71.89V15h5.19Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M81.9,23.94H80.75V16.13H78.27V15h6.1v1.09H81.9Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M88.8,23.94V15h1.14v8.9Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M95,23.94H93.86V16.13H91.38V15h6.11v1.09H95Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M109.05,22.8a4.64,4.64,0,0,1-6.51,0,4.54,4.54,0,0,1-1.32-3.3,4.51,4.51,0,0,1,1.32-3.3,4.32,4.32,0,0,1,3.25-1.35A4.37,4.37,0,0,1,109,16.2a4.53,4.53,0,0,1,1.32,3.3A4.57,4.57,0,0,1,109.05,22.8Zm-5.68-.74a3.45,3.45,0,0,0,4.84,0,3.51,3.51,0,0,0,1-2.56,3.42,3.42,0,1,0-6.84,0A3.55,3.55,0,0,0,103.37,22.06Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M112,23.94V15h1.39l4.28,7h0V15h1.15v8.9h-1.19l-4.53-7.25h0v7.26Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M100.94,36.91a6.3,6.3,0,1,0,6.33,6.29,6.23,6.23,0,0,0-6.13-6.3Zm0,10.11a3.83,3.83,0,1,1,3.54-4.09,2.35,2.35,0,0,1,0,.27A3.65,3.65,0,0,1,101,47h-.06ZM87.14,36.91a6.3,6.3,0,1,0,6.33,6.29,6.23,6.23,0,0,0-6.13-6.3Zm0,10.11a3.83,3.83,0,1,1,3.55-4.09,2.44,2.44,0,0,1,0,.27A3.65,3.65,0,0,1,87.21,47h-.07ZM70.73,38.84v2.68h6.4a5.6,5.6,0,0,1-1.45,3.37,6.66,6.66,0,0,1-5,2,7.12,7.12,0,0,1,0-14.23,6.88,6.88,0,0,1,4.82,1.91l1.9-1.88a9.38,9.38,0,0,0-6.72-2.7,9.78,9.78,0,1,0,0,19.56,8.89,8.89,0,0,0,6.82-2.75,8.74,8.74,0,0,0,2.32-6.25,9.3,9.3,0,0,0-.14-1.66Zm67.13,2.08a5.85,5.85,0,0,0-5.4-4,6,6,0,0,0-6,6c0,.08,0,.16,0,.24a6.16,6.16,0,0,0,6,6.3h.24A6.26,6.26,0,0,0,138,46.71l-2.15-1.43a3.55,3.55,0,0,1-3.1,1.74,3.18,3.18,0,0,1-3.05-1.91l8.42-3.47Zm-8.6,2.1a3.46,3.46,0,0,1,3.23-3.68h.07a2.42,2.42,0,0,1,2.34,1.34Zm-6.85,6.11h2.77V30.6h-2.77Zm-4.53-10.81h-.09a4.35,4.35,0,0,0-3.32-1.41,6.31,6.31,0,0,0,0,12.59,4.25,4.25,0,0,0,3.32-1.43h.09V49c0,2.41-1.29,3.7-3.37,3.7a3.46,3.46,0,0,1-3.17-2.25l-2.41,1a6,6,0,0,0,5.58,3.73c3.26,0,6-1.91,6-6.57V37.28h-2.63ZM114.71,47a3.83,3.83,0,0,1,0-7.64c1.88,0,3.35,1.62,3.35,3.85A3.51,3.51,0,0,1,114.84,47Zm36.11-16.4H144.2V49.12H147v-7h3.85a5.76,5.76,0,0,0,.48-11.51h-.51Zm.07,8.93H147V33.17h3.92a3.18,3.18,0,1,1,0,6.36ZM168,36.86a5.22,5.22,0,0,0-4.93,2.85l2.45,1a3,3,0,0,1,5.44,1v.18a6.18,6.18,0,0,0-2.89-.71c-2.64,0-5.34,1.46-5.34,4.16,0,2.5,2.17,4.08,4.61,4.08a3.91,3.91,0,0,0,3.52-1.81h.1V49h2.66V42C173.6,38.7,171.15,36.86,168,36.86ZM167.65,47c-.9,0-2.17-.45-2.17-1.57,0-1.43,1.57-2,2.93-2a5.07,5.07,0,0,1,2.53.62A3.36,3.36,0,0,1,167.65,47Zm15.67-9.75-3.17,8h-.08l-3.3-8h-3l4.94,11.23-2.81,6.25h2.87l7.61-17.48ZM158.43,49.12h2.76V30.6h-2.76Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M15.46,15.86a3,3,0,0,0-.69,2.07V50.67a3,3,0,0,0,.69,2.09l.11.11L33.91,34.52v-.43L15.57,15.75Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M40,40.64l-6.11-6.12v-.43L40,28l.14.08,7.24,4.11c2.07,1.17,2.07,3.09,0,4.27l-7.24,4.11Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M40.16,40.55l-6.25-6.24L15.46,52.76c.68.72,1.81.81,3.07.09l21.63-12.3"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M40.16,28.06,18.53,15.77c-1.26-.72-2.39-.64-3.07.09L33.91,34.32Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayStoreLogo);
export default __webpack_public_path__ + "static/media/playStoreLogo.639b046857e6bb21a940784d56c18baa.svg";
export { ForwardRef as ReactComponent };